import React from "react";

const ITEMS = [
  "MONTIEREN",
  "BAUEN",
  "WARTEN",
  "KRONES · KHS · TANNER",
  "BRAUEREIEN · SOFT DRINKS · MINERALWASSER",
  "DE · CH · INTERNATIONAL",
  "24/7 REAKTION",
  "3 MONTEURE · 15 JAHRE",
];

export default function Marquee() {
  const all = [...ITEMS, ...ITEMS];

  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-[#1d428a]/20 bg-[#1d428a] text-white overflow-hidden py-5"
    >
      <div className="flex marquee whitespace-nowrap">
        {all.map((it, i) => (
          <div key={i} className="flex items-center font-mono-tech px-8 shrink-0 text-base">
            <span className="w-1.5 h-1.5 bg-[#df4661] mr-6" />
            {it}
          </div>
        ))}
      </div>
    </div>
  );
}
